import { render } from "./rtl-welcome-wrap.vue?vue&type=template&id=bb73c656"
import script from "./rtl-welcome-wrap.vue?vue&type=script&lang=js"
export * from "./rtl-welcome-wrap.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__